import { FunctionalComponent, h } from "@stencil/core";

interface NavLink {
    href: string;
    label: string;
}

interface NavProps {
    baseClass: string;
    links: NavLink[];
}

export const Nav: FunctionalComponent<NavProps> = ({ baseClass, links }) => {
    const hasNav = typeof links !== "undefined" && links.length > 0;
    return hasNav ? (
        <nav class={`${baseClass}__nav`}>
            {links.map(({ href, label }) => (
                <a
                    class={`${baseClass}__nav-item`}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {label}
                </a>
            ))}
        </nav>
    ) : null;
};
